import React, { useEffect, useState } from "react";

let loadOnce = false;

function Home() {
	
	async function initButtonLoad(){
		const startBtn = document.getElementById('startButton');
		const video = document.getElementById('coverVideo');
		const enterBtn = document.getElementById('enterBtn');
		const startScreen = document.getElementById('startScreen');
		const coverOverlay = document.getElementById('coverOverlay');
		const loadingBarWrapper = document.getElementById('loadingBarWrapper');
		const loadingBar = document.getElementById('loadingBar');
		const loadingText = document.getElementById('loadingText');
		
		startBtn.addEventListener('click', () => {
			startBtn.style.display = 'none';
			loadingBarWrapper.style.display = 'block';
			loadingText.style.display = 'block';

			// Enhanced loading animation
			let width = 0;
			const loadingTexts = [
				"Loading Amazing Experience...",
				"Preparing Your Luck...",
				"Connecting to Blockchain...",
				"Almost Ready to Win!"
			];
			let textIndex = 0;

			const interval = setInterval(() => {
				width += 2;
				loadingBar.style.width = width + '%';

				if (width % 25 === 0 && textIndex < loadingTexts.length) {
					loadingText.textContent = loadingTexts[textIndex];
					textIndex++;
				}

				if (width >= 100) {
					clearInterval(interval);
					startScreen.style.display = 'none';
					coverOverlay.style.display = 'flex';

					// Enable sound and play video
					video.muted = false;
					video.currentTime = 0;
					video.play().catch(e => console.log("Autoplay error:", e));
				}
			}, 40); // Slightly slower for better UX
		});
		
		video.addEventListener('ended', () => {
			enterBtn.style.display = 'block';
		});
		
		// Allow user to skip
		video.addEventListener('click', () => {
			video.pause();
			enterBtn.style.display = 'block';
		});
		
		enterBtn.addEventListener('click', () => {
			coverOverlay.style.display = 'none';
			// Start main game logic here
		});
		
		const btn = document.getElementById("enterBtn");
		const cover = document.getElementById("coverOverlay");
		
		setTimeout(() => {
			btn.style.display = 'block';
			setTimeout(() => {
				btn.style.opacity = 1;

				// Add pulsing effect to indicate it's ready
				btn.style.animation = 'buttonReady 2s ease-in-out infinite';

				// Add style for the animation
				const style = document.createElement('style');
				style.textContent = `
				@keyframes buttonReady {
					0%, 100% {
						transform: scale(1);
						box-shadow: 0 8px 25px rgba(16, 185, 129, 0.4);
					}
					50% {
						transform: scale(1.05);
						box-shadow: 0 12px 35px rgba(16, 185, 129, 0.6);
					}
				}

				#enterBtn::before {
					content: '';
					position: absolute;
					top: 0;
					left: -100%;
					width: 100%;
					height: 100%;
					background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
					transition: left 0.6s ease;
				}

				#enterBtn:hover::before {
					left: 100%;
				}

				#enterBtn:hover {
					transform: scale(1.08) !important;
					box-shadow: 0 15px 40px rgba(16, 185, 129, 0.7) !important;
				}

				#enterBtn:active {
					transform: scale(0.95) !important;
					box-shadow: 0 4px 15px rgba(16, 185, 129, 0.6) !important;
				}
				`;
				document.head.appendChild(style);
			}, 50);
		}, 5000);
		
		btn.addEventListener("click", (e) => {
			// Enhanced click effect
			btn.style.transform = 'scale(0.95)';
			btn.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.6)';

			setTimeout(() => {
				btn.style.transform = 'scale(1.05)';
				btn.style.boxShadow = '0 12px 35px rgba(16, 185, 129, 0.8)';

				setTimeout(() => {
					cover.style.display = 'none';
					btn.style.transform = 'scale(1)';
					// Music will be controlled by the music player in the game
				}, 200);
			}, 150);
		});
	}
	
	useEffect(() => {
		if(!loadOnce){
			initButtonLoad(); //used inside useEffect
			loadOnce = true;
		}
		
	});
	
	
    return(
		<>
			<div 
				id="startScreen" 
				style={{
					position: "fixed"
					,top: 0 
					,left: 0
					,width: "100vw"
					,height: "100vh"
					,background: "linear-gradient(135deg, #1f2937, #111827)"
					,zIndex: 9999
					,display: "flex"
					,alignItems: "center"
					,justifyContent: "center"
					,flexDirection: "column"
					,color: "white"
					,fontFamily: "'Poetsen One', sans-serif"
				}}
			>
				<div 
					style={{
						textAlign:"center" 
						, marginBottom: "30px"
					}}
				>
					<h1 
						style={{
							fontSize: "48px"
							,background: "linear-gradient(135deg, #8f21e2, #a855f7, #fbbf24)" 
							,WebkitBackgroundClip: "text" 
							,WebkitTextFillColor: "transparent"
							,marginBottom: "10px"
						}}
					>
						SOL SCRATCH
					</h1>
					<p 
						style={{
							fontSize: "18px" 
							, color: "#9ca3af"
						}}
					>
						The Ultimate Blockchain Scratch Game
					</p>
				</div>

				<button 
					id="startButton" 
					style={{
						padding: "15px 40px"
						,fontSize: "22px"
						,borderRadius: "15px"
						,border: "none"
						,background: "linear-gradient(135deg, #8f21e2, #a855f7)"
						,color: "white"
						,cursor: "pointer"
						,fontFamily: "'Poetsen One', sans-serif"
						,boxShadow: "0 8px 25px rgba(143, 33, 226, 0.4)"
						,transition: "all 0.3s ease" 
					}}
					
				>
					🎮 Start The Game
				</button>

				<div 
					id="loadingBarWrapper" 
					style={{
						display:"none" 
						,marginTop:"30px" 
						,width: "60%" 
						,height: "20px" 
						,background: "#374151" 
						,borderRadius: "15px" 
						,overflow: "hidden"
					}}
				>
					<div 
						id="loadingBar" 
						style={{
							height: "100%" 
							,width: "0%" 
							,background: "linear-gradient(90deg, #8f21e2, #a855f7, #fbbf24)"
							,borderRadius: "15px"
							,transition: "width 0.3s ease"
						}}
					>
					</div>
				</div>
				<div id="loadingText" className="loading-text" style={{display:"none"}}>Loading Amazing Experience...</div>
			</div>

			<div 
				id="coverOverlay" 
				style={{
					position: "fixed"
					,top: 0 
					,left: 0
					,width: "100vw"
					,height: "100vh"
					,background: "black"
					,zIndex: 9998
					,display: "none"
					,alignItems: "center"
					,justifyContent: "center"
					,overflow: "hidden"
					,flexDirection: "column"
				}}
			>
				<video 
					id="coverVideo" 
					playsInline
					style={{
						position: "absolute"
						,top: 0
						,left: 0
						,width: "100%"
						,height: "100%"
						,objectFit: "cover"
					}}
				>
					<source src="/all/intro.mp4" type="video/mp4" />
					Your browser does not support the video tag.
				</video>

				<button 
				id="enterBtn" 
				style={{
				zIndex: 10000
				,marginTop: "auto"
				,marginBottom: "90px"
				,padding: "15px 35px"
				,fontSize: "20px"
				,background: "linear-gradient(135deg, #10b981, #059669)"
				,border: "none"
				,color: "white"
				,borderRadius: "15px"
				,display: "none"
				,cursor: "pointer"
				,fontFamily: "Poetsen One', sans-serif"
				,boxShadow: "0 8px 25px rgba(16, 185, 129, 0.4)"
				,transition: "all 0.3s ease"
				,position: "relative"
				,overflow: "hidden"
				}}
				>
				🏆 Enter to Win
				</button>
			</div>

			<div className="particles" id="particles"></div>
		</>
		
    )
}
export default Home